import script from "./DSPRequestExtensionModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./DSPRequestExtensionModal.vue?vue&type=script&lang=ts&setup=true"

import "./DSPRequestExtensionModal.vue?vue&type=style&index=0&id=fd688c66&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fd688c66"]])

export default __exports__